(function () {
  'use strict';

  angular.module('selectbox', []);
})();
